import React from 'react';
import { useLocation } from 'react-router-dom';

import FilledBadge from '@/components/Common/Badge/FilledBadge';
import BasicFooterButton from '@/components/Common/Button/BasicFooterButton';
import MenuHeader from '@/components/Header/MenuHeader';
import { CEO_NUMBER, COMPLETED } from '@/const/common';
import { formatPrice, formatTimeRange, phoneCall } from '@/utils/common';

const JobDetail = () => {
  const location = useLocation();
  const data = location.state.data;
  const isButtonDisable = data.status.code === COMPLETED;

  const isButtonDisabled = (status: string): boolean => {
    return status === COMPLETED;
  };

  const getBadgeTextColor = (status: string): string => {
    return isButtonDisabled(status) ? 'text-gray-6' : 'text-blue-3';
  };

  const renderTextContent = (textContent: string) => {
    const paragraphs = textContent.split('\n');
    return (
      <>
        {paragraphs.map((paragraph, index) => (
          <span key={index}>
            {index > 0 && <br />}
            {paragraph}
          </span>
        ))}
      </>
    );
  };

  return (
    <>
      <MenuHeader title={'일자리 구하기'}></MenuHeader>

      <div className="flex flex-col w-full pt-[60px] pb-[100px] overflow-scroll">
        <div className="px-4 pb-[18px] border-b-8 border-gray-1">
          <div className="flex flex-col gap-3  rounded-[4px]">
            <div className="mt-1">
              <div className="mt-1 mb-3">
                <FilledBadge
                  text={data.status.desc}
                  textColor={getBadgeTextColor(data.status.desc)}
                  bgColor={'bg-gray-1'}
                  rounded={'rounded-lg'}
                  fontWeight={'font-semibold'}
                ></FilledBadge>
              </div>
              <div className="text-lg font-semibold text-grey-10">{data.title}</div>
            </div>
            <hr />
            <dl className="flex flex-col gap-3">
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">운송 품목</dd>
                <dd className="text-gray-8">{data.transportItem}</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">운송 구간</dd>
                <dd className="text-gray-8"> {data.transportSection}</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">적재함 길이</dd>
                <dd className="text-gray-8"> {data.loadedInnerLength}m</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">근무 요일</dd>
                <dd className="text-gray-8">{data.workingDays?.desc}</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">근무 시간</dd>
                <dd className="text-gray-8"> {formatTimeRange(data.workingStartHour, data.workingEndHour)}</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">근무 기간</dd>
                <dd className="text-gray-8"> {!!data.period?.desc ? data.period?.desc : '-'}</dd>
              </dt>
              <dt className="flex gap-[10px]">
                <dd className="text-gray-7 w-[74px]">급여</dd>{' '}
                <dd className="text-gray-8">
                  {formatPrice(data.salary.toString()) + ' (' + data.salaryType?.desc + ')'}
                </dd>
              </dt>
            </dl>
          </div>
        </div>

        <div>
          <div className="rounded-[4px] p-[18px] text-gray-8 text-[15px] leading-[26px]">
            {renderTextContent(data.detailContents)}
          </div>
        </div>
      </div>
      <BasicFooterButton
        text="전화 문의"
        onClick={() => phoneCall(CEO_NUMBER)}
        disabled={isButtonDisable}
      ></BasicFooterButton>
    </>
  );
};

export default JobDetail;
